//* resize - создаем дополнительные события для $on
let windowWidth =  window.innerWidth
let windowHeight = window.innerHeight
window.addEventListener('resize', ()=> {
    if (windowWidth  !==  window.innerWidth) {
        $(window).trigger('resize:width')
        windowWidth =  window.innerWidth
    }
    if (windowHeight !== window.innerHeight) {
        $(window).trigger('resize:height')
        windowHeight = window.innerHeight
    }
})
//*
export function throttle(callee, timeoutMs) {
    //*
    let timer = null
    //*
    return (...args) => {
        //*
        if (timer) return
        //*
        timer = setTimeout(() => {
            //*
            callee(...args)
            //*
            clearTimeout(timer)
            timer = null
        }, timeoutMs)
    }
}

/**
 * Определяет целевой элемент для ссылки, если ссылка ведет на якорь на текущей странице.
 *
 * @param {HTMLElement} $link Элемент ссылки (<a>).
 * @returns {HTMLElement|undefined} - Целевой элемент (HTMLElement) якоря, если он найден на текущей странице, 
 *          в противном случае - undefined.  Возвращает `undefined` также, если у ссылки нет атрибута `href`.
 *          Если ссылка ведет на другой домен или путь, функция возвращает `undefined`.
 */
export function getLinkTarget($link) {
  let $targer;

  if ($link.href) {
    // Проверяем, ведет ли ссылка на текущую страницу.
    if ($link.origin + $link.pathname !== document.location.origin + document.location.pathname || !$link.hash) return; 
    // Если ссылка ведет на якорь на текущей странице, находим элемент с соответствующим ID.
    $targer = document.querySelector($link.hash.trim());
  }

  return $targer;
}
